import React from 'react';

import {ReactComponent as LoadingSvg} from './loading.svg'

function Loading() {
  return (
    <>
    <div className='flex justify-center items-center h-screen'>
        <div className="flex-col">
            <div className="flex"></div>
    <LoadingSvg width={180} className='flex' />
    <div className="flex"></div>
    </div>
    </div>
    </>
  );
};

export default Loading;
